exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-dept-tree-v2[data-v-b2025142]{height:100%;width:100%x}.yxtbiz-dept-tree-v2 .yxtbiz-dept-tree-v2-search[data-v-b2025142]{height:40px}.yxtbiz-dept-tree-v2-radio[data-v-b2025142]{overflow:hidden;display:inline-block;vertical-align:bottom;width:20px}\n", ""]);

